import template from './partnerDelete.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, partnersService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onAccountDelete(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                accounts: _params.accounts,
                selectedAccounts: _params.selectedAccounts,
                isMedia: ctrl.$mdMedia
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (deletedUsers) {
              var len = deletedUsers.length;
              while (len--) {
                ctrl.onFinished({ account: deletedUsers[len].account });
                delete deletedUsers[len].account;
              }

              partnersService.deletePartners(deletedUsers).then(function (data) {
                if (data.status) {
                  uiService.toast({
                    text: {
                      p1: deletedUsers.length,
                      p2: 'Partner(s)',
                      p3: 'have been deleted'
                    }
                  });
                }
              });
            });

          function dialogController($mdDialog, accounts, selectedAccounts, isMedia) {
            this.deletedUsers = [];
            this.accounts = accounts;
            this.IsMedia = isMedia;
            var len = selectedAccounts.length;
            while (len--) {
              this.deletedUsers.push({
                idDeleted: selectedAccounts[len].id,
                idReplaced: '',
                deletedOwner: {
                  avatar: selectedAccounts[len].user.avatar,
                  name:
                    selectedAccounts[len].user.firstName +
                    ' ' +
                    selectedAccounts[len].user.lastName
                },
                account: selectedAccounts[len]
              });
            }

            this.confirm = function () {
              $mdDialog.hide(this.deletedUsers);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
